module.exports = __webpack_public_path__ + "img/hot_5.d3eafe63.png";